import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import sponsorService from '../../services/sponsorService';
import './SponsorForm.css';

function SponsorForm() {
  const { id } = useParams(); // <- nome correto da rota
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [link, setLink] = useState('');
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [preview, setPreview] = useState('');

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !image) {
      setMessage('Por favor, preencha o nome e selecione uma imagem.');
      return;
    }

    if (!id) {
      setMessage('Erro: ID do campeonato não encontrado. Não é possível continuar.');
      return;
    }

    setLoading(true);
    setMessage('');

    const formData = new FormData();
    formData.append('name', name);
    formData.append('link', link);
    formData.append('logo', image);

    try {
      await sponsorService.create(id, formData);

      setMessage('✅ Patrocinador cadastrado com sucesso! Redirecionando...');
      setTimeout(() => {
        navigate(`/championships/${id}/sponsors`);
      }, 2000);

    } catch (error) {
      console.error('Erro ao cadastrar patrocinador:', error);
      const errorMessage =
        error.response?.data?.message || error.message || '❌ Falha ao cadastrar o patrocinador.';
      setMessage(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container sponsor-form-container">
      <h2>Cadastrar Novo Patrocinador</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Nome do Patrocinador*</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            disabled={loading}
          />
        </div>
        <div className="form-group">
          <label htmlFor="link">Link do Site (opcional)</label>
          <input
            type="url"
            id="link"
            placeholder="https://www.exemplo.com"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            disabled={loading}
          />
        </div>
        <div className="form-group">
          <label htmlFor="image">Logo do Patrocinador*</label>
          <input
            type="file"
            id="image"
            accept="image/png, image/jpeg, image/webp"
            onChange={handleImageChange}
            required
            disabled={loading}
          />
        </div>

        {preview && (
          <div className="image-preview">
            <p>Pré-visualização:</p>
            <img
              src={preview}
              alt="Pré-visualização do logo"
              style={{ width: '150px', border: '1px solid #ddd', padding: '5px' }}
            />
          </div>
        )}

        <button type="submit" disabled={loading} className="btn-submit">
          {loading ? 'Cadastrando...' : 'Cadastrar Patrocinador'}
        </button>

        {message && (
          <p className={`form-message ${message.includes('❌') ? 'error' : 'success'}`}>
            {message}
          </p>
        )}
      </form>
    </div>
  );
}

export default SponsorForm;
